import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const map = {
  period1: '第一階段',
  period2: '第二階段',
  period3: '第三階段',
};
const MissionBar = ({ assignments, current, onNavTo }) => (
  <div className="missions-bar-container">
    <div className="missions-bar row mx-0 p-1">
      {assignments.map((a, i) => (
          <div
            key={a.key}
            className="col col-auto p-1 mx-0 mx-md-2 mission-item"
          >
            {a && a.opened ? (
              a._id != current ? (
                <Link
                  className={'mission-item'}
                  to={`/app/missions/${a._id}`}
                >
                  {a.title}
                </Link>
              ) : (
                <div className={'mission-item active'}>
                  {map[a.key.split('_')[0]]}
                </div>
              )
            ) : (
              <div className={'mission-item}'}>
                <img src="/assets/img/lock.png" />
                {map[a.key.split('_')[0]]}
              </div>
            )}
          </div>
      ))}
    </div>
  </div>
);

export default MissionBar;
